import { useQuery } from '@tanstack/react-query';
import { fetchOrderDetail } from '../api/orderDetail.api';

export const useOrderDetail = (orderId: string) =>
  useQuery({
    queryKey: ['orderDetail', orderId],
    queryFn: () => fetchOrderDetail(orderId),
    enabled: !!orderId
  });
